import { render, staticRenderFns } from "./DualViewSettingTrigger.vue?vue&type=template&id=16681392"
import script from "./DualViewSettingTrigger.vue?vue&type=script&lang=js"
export * from "./DualViewSettingTrigger.vue?vue&type=script&lang=js"
import style0 from "./DualViewSettingTrigger.vue?vue&type=style&index=0&id=16681392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports